import { useContext } from 'react';

import InfoContext from 'contexts/info';

const useInfo = () => useContext(InfoContext)!;

export default useInfo;
